import { followingSidebar } from '../utils/sidebar.utils.js';

const aboutSectorSection = document.querySelector('.about-sector-sec');

if (aboutSectorSection) {
    const desktopBreakpoint = 769;
    const heightDifferenceThreshold = 150;
    const textSidebar = aboutSectorSection.querySelector('.about-sector-sec__content');
    const specialistsSidebar = aboutSectorSection.querySelector('.about-sector-sec__list-wr');
    const textSidebarInner = textSidebar?.querySelector('.about-sector-sec__content-inner');
    const specialistsSidebarInner = specialistsSidebar?.querySelector('.about-sector-sec__list-inner');
    const contentSticky = aboutSectorSection.querySelector('.about-sector-sec__wrap');
    let destroySidebar = null;
    let activeSidebar = null;
    let syncFrame = null;

    const textSidebarConfig = {
        sidebar: textSidebar,
        sidebarInnerSelector: '.about-sector-sec__content-inner',
    };

    const specialistsSidebarConfig = {
        sidebar: specialistsSidebar,
        sidebarInnerSelector: '.about-sector-sec__list-inner',
    };

    const destroyActiveSidebar = () => {
        if (destroySidebar) {
            destroySidebar();
            destroySidebar = null;
        }

        activeSidebar = null;
    };

    const getSidebarConfig = () => {
        if (
            window.innerWidth < desktopBreakpoint ||
            !textSidebarInner ||
            !specialistsSidebarInner ||
            !contentSticky
        ) {
            return null;
        }

        const textHeight = textSidebarInner.getBoundingClientRect().height;
        const specialistsHeight = specialistsSidebarInner.getBoundingClientRect().height;

        if (Math.abs(textHeight - specialistsHeight) <= heightDifferenceThreshold) {
            return null;
        }

        return textHeight < specialistsHeight ? textSidebarConfig : specialistsSidebarConfig;
    };

    const syncSidebar = () => {
        const nextSidebar = getSidebarConfig();

        if (nextSidebar === activeSidebar) {
            return;
        }

        destroyActiveSidebar();

        if (nextSidebar) {
            destroySidebar = followingSidebar({
                ...nextSidebar,
                contentSticky,
                isHeaderCalc: true,
                gap: 10,
                bottomGap: 40,
                directionThreshold: 8,
            });
            activeSidebar = nextSidebar;
        }
    };

    const scheduleSync = () => {
        if (syncFrame) {
            return;
        }

        syncFrame = requestAnimationFrame(() => {
            syncFrame = null;
            syncSidebar();
        });
    };

    syncSidebar();
    window.addEventListener('resize', scheduleSync);
    window.addEventListener('load', scheduleSync, { once: true });

    if (window.ResizeObserver && textSidebarInner && specialistsSidebarInner) {
        const resizeObserver = new ResizeObserver(scheduleSync);
        resizeObserver.observe(textSidebarInner);
        resizeObserver.observe(specialistsSidebarInner);
    }
}
